import { reportFormUrl } from "~/constants";
import { trackReportFormClicked } from "~/analytics";
import { type UserProfile } from "./schemas/user";

type ReportType = "Feedback" | "Bug" | "";

type ReportFormURLOptions = {
  email?: string;
  reportType?: ReportType;
  sessionId?: string;
  version?: string;
};

export function getCookie(name: string) {
  return document.cookie
    .split("; ")
    .find((c) => c.startsWith(name + "="))
    ?.split("=")[1];
}

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function formatReportFormUrl(options: ReportFormURLOptions) {
  const params = new URLSearchParams();
  if (options.email) {
    params.append("text_mkt554dj", options.email);
  }
  if (options.reportType) {
    params.append("color_mkqwqef7", options.reportType);
  }
  if (options.sessionId) {
    params.append("text_mkt9h6m9", options.sessionId);
  }
  if (options.version) {
    params.append("text_mkt94mte", options.version);
  }
  return `${reportFormUrl}?${params.toString()}`;
}

export function getReportUrl(
  reportType: ReportType,
  pathname: string,
  user: UserProfile | null
) {
  let sessionId = "";

  if (!pathname.startsWith("/chat/new") && pathname.startsWith("/chat/")) {
    // extract sesionId from the path
    sessionId = pathname.split("/").pop() || "";
  }

  return formatReportFormUrl({
    email: user ? (user.is_anon ? "" : user.email) : "",
    sessionId,
    reportType,
    version: import.meta.env.VITE_VERSION,
  });
}

export function handleReportClicked(
  reportType: ReportType,
  pathname: string,
  user: UserProfile | null
) {
  const reportFormUrlForSupport = getReportUrl(reportType, pathname, user);
  trackReportFormClicked();
  window.open(reportFormUrlForSupport, "_blank");
}
